import dayjs from "dayjs";
import { useState } from "react";
import { getXlsxDownloadHref } from "../../utils";

const XlsxDownload = ({ api, params = {}, name }) => {
  const [month, setMonth] = useState(dayjs().format("YYYY-MM"));

  return (
    <>
      <input
        className="d-none"
        type="month"
        style={{
          padding: 8,
          border: "1px solid #eee",
          color: "#9a9a9a",
          marginRight: 4,
        }}
        value={month}
        onChange={(e) => setMonth(e.target.value)}
      />
      <button
        className="download border-line mouse zoom_font"
        type="button"
        onClick={async () =>
          await getXlsxDownloadHref({
            api: api,
            params: {
              ...params,
              starttime: dayjs(month).startOf("month").format("YYYYMMDD"),
              endtime: dayjs(month).endOf("month").format("YYYYMMDD"),
              count: 10000,
              page: 1,
              isxlsx: 1,
            },
            name: name,
          })
        }
      ></button>
    </>
  );
};

export default XlsxDownload;
